define(function () {
	const GenericCollection = require('civicsBase/generic_collection');
	const CommonInspectionCode = require('civicsViews/inspection_request/common/common');
	const CN = require('civicsUtils/constants');
	const InspectionModel = require('civicsModels/inspection_model');
	const ReviewModel = require('civicsModels/review_model');
	return GenericCollection.extend({

		dataTypeContext: [{
			generateId: function(obj, key) {
				// generate unique id and add data type to model
				obj._appId = this.dataType.type + "|" + obj.assignmentType + "|" + obj.id;
				obj._dataType = this.dataType.type;
			},
			type: 'assignments',
			url: 'core/views/assignments',
			collectionParse: function (data) {
				for (i = 0; i < data.length; i++) {
					switch(data[i].assignmentType) {
								case 'BuildingInspection':
										data[i]._cdrType = 'building';
										data[i]._dataType = 'building.Inspection';
										data[i]._assignmentType = 'inspection';
										break;
								case 'LicenseInspection':
										data[i]._cdrType = 'businessLicense';
										data[i]._dataType = 'businessLicense.Inspection';
										data[i]._assignmentType = 'inspection';
										break;
								case 'CaseInspection':
										data[i]._cdrType = 'codeEnforcement';
										data[i]._dataType = 'codeEnforcement.Inspection';
										data[i]._assignmentType = 'inspection';
										break;
								case 'PlanningInspection':
										data[i]._cdrType = 'planning';
										data[i]._dataType = 'planning.Inspection';
										data[i]._assignmentType = 'inspection';
										break;
								case 'ProjectInspection':
										data[i]._cdrType = 'project';
										data[i]._dataType = 'project.Inspection';
										data[i]._assignmentType = 'inspection';
										break;
								case 'TradeInspection':
										data[i]._cdrType = 'tradeLicense';
										data[i]._dataType = 'tradeLicense.Inspection';
										data[i]._assignmentType = 'inspection';
										break;
								case 'UseInspection':
										data[i]._cdrType = 'use';
										data[i]._dataType = 'use.Inspection';
										data[i]._assignmentType = 'inspection';
										break;
								case 'BuildingReview':
										data[i]._cdrType = 'building';
										data[i]._dataType = 'building.Review';
										data[i]._assignmentType = 'review';
										break;
								case 'LicenseReview':
										data[i]._cdrType = 'businessLicense';
										data[i]._dataType = 'businessLicense.Review';
										data[i]._assignmentType = 'review';
										break;
								case 'CaseReview':
										data[i]._cdrType = 'codeEnforcement';
										data[i]._dataType = 'codeEnforcement.Review';
										data[i]._assignmentType = 'review';
										break;
								case 'PlanningReview':
										data[i]._cdrType = 'planning';
										data[i]._dataType = 'planning.Review';
										data[i]._assignmentType = 'review';
										break;
								case 'ProjectReview':
										data[i]._cdrType = 'project';
										data[i]._dataType = 'project.Review';
										data[i]._assignmentType = 'review';
										break;
								case 'TradeReview':
										data[i]._cdrType = 'tradeLicense';
										data[i]._dataType = 'tradeLicense.Review';
										data[i]._assignmentType = 'review';
										break;
								case 'UseReview':
										data[i]._cdrType = 'use';
										data[i]._dataType = 'use.Review';
										data[i]._assignmentType = 'review';
										break;

								default:
										console.log('undefined/invalid product family from the assignment response');
						}
					data[i].application = data[i].instrument;
					data[i].result = data[i].status;
					data[i].resultDescription = data[i].statusDescription;
					data[i].inspectionType={description:data[i].description,portalDescription:data[i].portalDescription,};
					data[i].reviewType={description:data[i].description,portalDescription:data[i].portalDescription,};
					//if (data)
					data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description);
					if( data[i].computedDescription.trim().length <= 0 ){
						data[i].computedDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
					}
					//Set the Series Number
					if( data[i]._assignmentType == 'inspection'){
						data[i].inspectionTypeNumber = data[i].subTypeNumber;
					}
					else {
						data[i].reviewTypeNumber = data[i].subTypeNumber;
					}
					// set the displayDate
					var isClosed = data[i].result && data[i].result.trim().length > 0;
					if (isClosed) {
						data[i].displayDate = data[i].resultDateTime;
					} else {
						// call the common helper to get the dates since it has the shared logic
						var psuedoView = {};
						psuedoView.config = {};
						psuedoView.config.INSPECTION_STATE = CN.INSPECTION_STATE();
						psuedoView.config.captureRequestDateToCallDate = App.captureRequestDateToCallDate;
						psuedoView.model = new InspectionModel();
						psuedoView.model.set('scheduledDateTime', data[i].scheduledDateTime);
						psuedoView.model.set('callDateTime', data[i].callDateTime);
						psuedoView.model.set('result', data[i].result);
						psuedoView.model.set('resultDateTime', data[i].resultDateTime);
						psuedoView.model.set('startDateTime', data[i].startDateTime);
						psuedoView.model.set('completedDateTime', data[i].completedDateTime);
						psuedoView.model.set('inspectionHours', data[i].inspectionHours);
						psuedoView.model.set('isPartial', data[i].isPartial);
						var common = CommonInspectionCode.commonHelpers(psuedoView)
						data[i].displayDate = common.getInspectionAssignmentScheduledDate();
						if (data[i].displayDate == '') {
							data[i].displayDate = CN.DATE_TIME_MIN_VAL;
						}
					}

				}
				return data;
			},
			select: [
				'id',
				'AssignmentType',
				'AssignmentSubType',
				'SubTypeNumber',
				'Instrument',
				'AssignedToProvider',
				'ProductFamily',
				'PortalDescription',
				'Description',
				'Status',
				'StatusDescription',
				'AddedDateTime',
				'scheduledDateTime',
				'CallDateTime',
				'DueDate',
				'IssuedDateTime',
				'CompletedDateTime',
				'ResultDateTime',
				'ScheduledDateTime',
				'StartDateTime',
				'isPartial',
				'timePreference',
				'actualTime',
				'Location',
				'ContactPerson',
				'ContactInfo',
				'SpecialInstructions'
			]
		}]
	});
});
